export default __webpack_public_path__ + "static/media/portfolio2.950e2599.png";